<div class="header">
    <div class="header-logos" style="display: inline;">
        <a class="header-logos__link" style="display: inline-block;" href="https://seguros.sura.cl" title="Seguros SURA" target="_blank" rel="noopener noreferrer"><img src="/assets/img/logo-seguroxkm.svg" alt="Logo Seguro x Km" /></a>
        <!-- <a class="header-logos__link" style="display: inline-block;" target="_blank" rel="noopener noreferrer"><img [src]="urlAseguradora"/></a> -->
    </div>
    <app-sura-select [items]="autos" (selected)=onChangeCar($event)></app-sura-select>
</div>
